import React from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../lib/authLib";

interface LogoutButtonProps {
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Error during logout", error);
    }
    localStorage.removeItem("cobutlerToken");
    localStorage.removeItem("cobutlerTokenExpiry");
    navigate(0);
  };

  return (
    <button onClick={handleLogout} className={className}>
      Logout
    </button>
  );
};

export default LogoutButton;
